var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4990_24501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.85292 16.3269V11.3269H12.204V16.3269C12.204 16.8769 12.6934 17.3269 13.2917 17.3269H16.555C17.1532 17.3269 17.6427 16.8769 17.6427 16.3269V9.32687H19.4919C19.9923 9.32687 20.2316 8.75687 19.8509 8.45687L10.7573 0.926875C10.3439 0.586875 9.71297 0.586875 9.29962 0.926875L0.206019 8.45687C-0.163817 8.75687 0.0646112 9.32687 0.564977 9.32687H2.41416V16.3269C2.41416 16.8769 2.90365 17.3269 3.50191 17.3269H6.76516C7.36343 17.3269 7.85292 16.8769 7.85292 16.3269Z",
    fill: "url(#paint0_linear_4990_24501)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4990_24501",
    x1: 0.0233548,
    y1: 9.10919,
    x2: 20.0383,
    y2: 9.10919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#23B3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#247EAF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4990_24501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGreen);
export default __webpack_public_path__ + "static/media/homeGreen.efe4b3f483664b4c2520889a197820c0.svg";
export { ForwardRef as ReactComponent };